function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRoninLogo = function SvgRoninLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 30.8",
    style: {
      enableBackground: "new 0 0 22 30.8"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.4v19c0 .4.1.7.2 1 .2.3.4.6.7.8l9 7.2c.3.3.7.4 1.1.4s.8-.1 1.1-.4l9-7.2c.3-.2.5-.5.7-.8.2-.3.2-.7.2-1v-19c0-.6-.3-1.2-.7-1.7-.4-.5-1-.7-1.7-.7H2.4C1.7 0 1.1.2.7.7c-.4.4-.7 1-.7 1.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#004de5"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ronin-logo_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 11,
    y1: 27.233,
    x2: 11,
    y2: 8.9,
    gradientTransform: "matrix(1 0 0 -1 0 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 11V6.8c0-.5-.2-1.1-.6-1.5-.4-.4-.9-.6-1.5-.6H6.6c-.5.1-1 .3-1.4.7-.4.4-.6.9-.6 1.4v12c0 .3.1.6.2.9.1.3.3.5.6.7L8.5 23l.1.1h.1l.1-.1v-8.6c0-.1 0-.1.1-.2 0 0 .1-.1.2-.1h2.3c.4 0 .8.2 1.1.5.3.3.5.7.5 1.1V23l.1.1h.1s.1 0 .1-.1l3.2-2.6c.2-.2.4-.4.6-.7.1-.3.2-.6.2-.9v-3.7c0-.5-.2-1.1-.6-1.5-.4-.4-.9-.6-1.5-.6.5 0 1.1-.2 1.4-.6.6-.3.8-.9.8-1.4zm-5.9 1H9.2c-.1 0-.1 0-.2-.1 0 0-.1-.1-.1-.2V7.1c0-.1.1-.1.1-.2 0 0 .1-.1.2-.1h3.6c.1 0 .1 0 .2.1 0 0 .1.1.1.2v3.4c0 .4-.2.8-.5 1.1-.3.3-.7.4-1.1.4z",
    style: {
      fill: "url(#ronin-logo_svg__a)"
    }
  }));
};
export default SvgRoninLogo;